import Vue from 'vue'
import router from "./router";
import store from "./store/store";
import BootstrapVue  from 'bootstrap-vue'
import App from './App.vue'
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

Vue.component('apexchart', VueApexCharts)
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserMd, faEraser, faVrCardboard, 
         faGlasses, faHandshake, faUserClock,
         faDoorClosed, faDoorOpen, faInfoCircle,
         faUserInjured, faUserPlus, faBook,
         faTrashAlt, faFolderOpen, faTimes,
         faFileUpload, faFileAlt, faPaperPlane,
         faSyncAlt, faLongArrowAltLeft, faTicketAlt,
         faUsers, faUserTag, faUserCog,
         faSignInAlt, faSignOutAlt, faHandPointRight,
         faBarcode, faFolder, faFolderPlus, 
         faLevelDownAlt, faFolderMinus, faEllipsisV,
         faFileMedical, faHome, faStethoscope,
         faCompass, faIdCard, faMedkit,
         faTable, faChess, faSitemap, faPhoneSquareAlt,
         faClinicMedical, faMicroscope, faTablets,
         faQrcode, faBusinessTime, faVirusSlash,
         faAddressCard, faExternalLinkAlt, faFileSignature,
         faServer, faFileVideo, faFilePowerpoint, 
         faPrint, faIdBadge, faFileImport, faSearchLocation, 
         faPassport, faThumbsUp, faGlobeAmericas
         } from '@fortawesome/free-solid-svg-icons'


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserMd, faEraser, faVrCardboard, 
            faGlasses, faHandshake, faUserClock, 
            faDoorClosed, faDoorOpen, faInfoCircle,
            faUserInjured, faUserPlus, faBook,
            faTrashAlt, faFolderOpen, faTimes,
            faFileUpload, faFileAlt, faPaperPlane,
            faSyncAlt, faLongArrowAltLeft, 
            faTicketAlt, faUsers, faVirusSlash,
            faUserTag, faUserCog, faSignInAlt, 
            faSignOutAlt, faHandPointRight, faBarcode,
            faFolder, faFolderPlus, faLevelDownAlt,
            faFolderMinus, faEllipsisV, faFileMedical,
            faHome, faStethoscope, faCompass,
            faIdCard, faMedkit, faTable, faPhoneSquareAlt,
            faSitemap, faClinicMedical, faMicroscope,
            faTablets, faBusinessTime, faQrcode,
            faChess, faAddressCard, faExternalLinkAlt,
            faFileSignature, faServer, faFileVideo,
            faFilePowerpoint, faPrint, faIdBadge,
            faFileImport, faSearchLocation, faPassport,
            faThumbsUp, faGlobeAmericas
          );

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})


Vue.config.devtools = true;


// WEBPACK FOOTER //
// ./src/main.js